// Names are not authentication tokens, but use cryptographic randomness to avoid
// short Math.random collisions and satisfy the security review without fallbacks.
export function newDlpProfileName(prefix: string): string {
    const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
    const suffix = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${prefix}_${suffix}`;
}
